import React from "react";
import BuildIcon from "../assets/icon_build.svg";
import SolutionIcon from "../assets/icon_solutions.svg";
import InterfaceIcon from "../assets/icon_interface.svg";
import IconFullStack from "../assets/icon_fullstack.svg";
import Reveal from "./Reveal";

const offerings = [
  {
    icon: BuildIcon,
    title: "Building Intuitive User Experiences",
    desc: "We craft seamless, human-centered digital journeys that delight and deliver.",
  },
  {
    icon: SolutionIcon,
    title: "Develop Fit-For-Purpose Mobile Solutions",
    desc: "Bespoke mobile apps engineered for performance, scalability, and real-world impact.",
  },
  {
    icon: InterfaceIcon,
    title: "Engaging User Interface Design",
    desc: "Visually striking, functionally brilliant interfaces that turn users into loyal advocates.",
  },
  {
    icon: IconFullStack,
    title: "Full Stack Design Services",
    desc: "From front-end finesse to back-end power — comprehensive design that does it all.",
  },
];

const WhatWeOffer = () => {
  return (
    <section className="bg-ink px-6 sm:px-12 lg:px-20 py-28">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start">
        {/* Left */}
        <Reveal>
          <p className="eyebrow mb-5">What we offer</p>
          <h2 className="display-title mb-8">
            End-to-end product work
          </h2>
          <div className="w-20 h-[3px] rounded-full bg-brand-grad mb-8" />

          <div className="space-y-5 text-body text-muted">
            <p>
              At Deep-C Vision, we provide end-to-end digital design and
              development services tailored to meet the needs of modern
              businesses. From crafting seamless UX/UI experiences to building
              high-performance mobile applications, our team delivers solutions
              that are as functional as they are visually compelling.
            </p>
            <p>
              We specialise in full stack development, bringing together
              powerful front-end interfaces with scalable back-end architecture
              to create products that grow with your users.
            </p>
            <p>
              Whether you're launching an MVP or refining an existing product,
              we turn ideas into beautifully engineered digital experiences —
              fast, focused, and future-ready.
            </p>
          </div>
        </Reveal>

        {/* Right */}
        <div className="grid gap-4">
          {offerings.map(({ icon, title, desc }, i) => (
            <Reveal key={title} delay={i * 100}>
              <div className="surface-card p-7 flex items-start gap-5">
                <img
                  src={icon}
                  alt=""
                  aria-hidden="true"
                  className="w-11 h-11 object-contain shrink-0 mt-0.5"
                />
                <div>
                  <h3 className="text-[17px] font-medium text-paper mb-2 leading-snug">
                    {title}
                  </h3>
                  <p className="text-sm text-muted leading-relaxed">{desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeOffer;
